<template>
    <div>
        <div>
            {{ $t('messages.cutoff_percent_explainer', { percent }) }}
        </div>
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-3">
            <div v-for="group in groupsWithCounters" :key="`${group.id}_${percent}`">
                <div>
                    <div>{{ group.name }}: {{ group.count }} ({{ $t('messages.cutoff') }}: {{ group.cutOff }})</div>
                    <div>
                        <div v-for="student in group.filteredStudents" :key="student.id">
                            {{ student.full_name }}: ({{ student.experience_total }})
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CatchUpPercentExplainer',
    props: {
        groups: {
            type: Array,
            required: true,
        },
        percent: {
            type: Number,
            required: true,
        },
    },
    computed: {
        groupsWithCounters: function () {
            return this.groups.map((g) => {
                const cutOff = (g.median * this.percent) / 100;
                const filteredStudents = g.students.filter((s) => s.experience_total < cutOff);
                return {
                    id: g.id,
                    name: g.name,
                    median: g.median,
                    cutOff: cutOff,
                    filteredStudents: filteredStudents,
                    count: filteredStudents.length,
                };
            });
        },
    },
};
</script>
